import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    loadingStatus: "idle",
    error: null
}

export const fetchViolationsDetails = createAsyncThunk(
    'violationDetails/fetchViolationsDetails',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/surveys/violations/${id}`,
                'GET',
                null,
                customHeaders
            )
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const violationsDetailsSlice = createSlice({
    name: 'violationsDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchViolationsDetails.pending, (state) => {
                state.columns = [];
                state.data = [];
                state.loadingStatus = "loading";
                state.error = null
            })
            .addCase(fetchViolationsDetails.fulfilled, (state, action) => {
                state.columns = action.payload.columns || [];
                state.data = action.payload.data || [];
                state.loadingStatus = "idle";
                state.error = null
            })
            .addCase(fetchViolationsDetails.rejected, (state, action) => {
                state.columns = [];
                state.data = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default violationsDetailsSlice.reducer;